{
  "columns": [
    {
      "header_id": "participantPplId",
      "header_label": "Participant PPL ID",
      "jsonpath": "participantPplId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "consumerName",
      "header_label": "Participant Name",
      "jsonpath": "consumerName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "pplProviderId",
      "header_label": "Provider PPL ID",
      "jsonpath": "pplProviderId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "providerName",
      "header_label": "Provider Name",
      "jsonpath": "providerName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "code",
      "header_label": "Service Code",
      "jsonpath": "code",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "rate",
      "header_label": "Rate",
      "jsonpath": "rate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "fromDate",
      "header_label": "From Date",
      "jsonpath": "fromDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "toDate",
      "header_label": "To Date",
      "jsonpath": "toDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "createdby",
      "header_label": "Created By",
      "jsonpath": "createdby",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "createddate",
      "header_label": "Created Date",
      "jsonpath": "createddate",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "modifiedby",
      "header_label": "Modified By",
      "jsonpath": "modifiedby",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "modifieddate",
      "header_label": "Modified Date",
      "jsonpath": "modifieddate",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    },
    {
      "header_id": "ptcPrvdrXRatesId",
      "header_label": "Id",
      "jsonpath": "ptcPrvdrXRatesId",
      "isDisplayedAtHeader": "n",
      "isSearchable": "n"
    }
  ],
  "buttons": [],
  "apiDetails": "ParticipantProviderList.json",
  "pageName": "Participant-provider-list",
  "orderByColumn": ["ptcPrvdrXRatesId"],
  "orderBy": ["desc"]
}
